<div class="modal-body">
  <div class="row">
    <div class="col-xs-12 col-md-6">
      <h4>Datos Personales</h4>
    </div>
  </div>
  <form [formGroup]="reactiveForm" (ngSubmit)="(submitForm)" class="smart-form">
    <fieldset>
      <div class="row">
        <dynamic-form
          class="form-registration"
          [formInputs]="dinamicFormInputsData"
          [suggestedNumberCols]="1"
          [templateInputsExternal]="{
            country: countryTemplate,
            dniPerson: dniTemplate,
            identificationType: identificationTypeTemplate,
            namePerson: personTemplate,
            personType: personTypeTemplate
          }">
        </dynamic-form>
        <!-- Nombre de persona -->
        <ng-template #personTemplate>
          <div class="col-xs-12">
            <div class="form-group">
              <label class="label" htmlFor="namePerson">{{
                getDynamicFormLabelByInputName('namePerson')
              }}</label>
              <input
                id="namePerson"
                class="form-control"
                formControlName="namePerson" />
            </div>
            <div
              *ngIf="
                reactiveForm.get('namePerson').invalid &&
                reactiveForm.get('namePerson').touched
              ">
              <p class="error">El nombre de la persona es obligatorio</p>
            </div>
          </div>
        </ng-template>
        <!-- País -->
        <ng-template #countryTemplate>
          <div class="col-xs-12">
            <div class="form-group">
              <label class="label" [htmlFor]="'countryIso'">{{
                getDynamicFormLabelByInputName('country')
              }}</label>
              <select2
                id="countryIso"
                name="countries"
                [data]="countriesDto"
                formControlName="countryIso"
                (update)="onChangeCountry($event)">
              </select2>
              <div
                *ngIf="
                  reactiveForm.get('countryIso').invalid &&
                  reactiveForm.get('countryIso').touched
                ">
                <p class="error">El País es obligatorio</p>
              </div>
            </div>
          </div>
        </ng-template>
        <!-- Tipo de identificacion -->
        <ng-template #identificationTypeTemplate>
          <div class="col-xs-12">
            <div class="form-group">
              <label class="label">{{
                getDynamicFormLabelByInputName('identificationType')
              }}</label>
              <label class="select">
                <select
                  (change)="onChangeIdentificationType($event)"
                  formControlName="identificationType">
                  <option [ngValue]="null" disabled selected hidden>
                    Seleccione una opción
                  </option>
                  <option
                    *ngFor="
                      let identificationType of identificationTypesByCountry
                    "
                    [value]="identificationType.cdOption">
                    {{ identificationType?.label }}
                  </option>
                </select>
                <i></i>
              </label>
              <div
                *ngIf="
                  reactiveForm.get('identificationType').invalid &&
                  reactiveForm.get('identificationType').touched
                ">
                <p class="error">El tipo de identificación es obligatorio</p>
              </div>
            </div>
          </div>
        </ng-template>
        <!-- Documento de identificacion -->
        <ng-template #dniTemplate>
          <div class="col-xs-12">
            <div class="form-group">
              <label class="label">{{
                getDynamicFormLabelByInputName('dniPerson')
              }}</label>
              <input
                class="form-control"
                formControlName="dniPerson"
                (input)="onInputDni($event)"
                name="dni" />
            </div>
            <div *ngIf="customValidationErrorsForDni">
              <p class="error" *ngIf="countryCodeSel !== 'CL'">
                El formato no es válido
              </p>
              <p class="error" *ngIf="countryCodeSel === 'CL'">
                El formato tiene un mínimo de 7 dígitos más un carácter
                verificador numérico o la letra 'K'
              </p>
            </div>
          </div>
        </ng-template>
        <!-- Tipo de persona -->
        <ng-template #personTypeTemplate>
          <div class="col-xs-12">
            <label class="label" htmlFor="personType">{{
              getDynamicFormLabelByInputName('personType')
            }}</label>
            <label class="select">
              <select
                id="personType"
                class="formControl"
                formControlName="personType">
                <option [ngValue]="null" disabled selected hidden>
                  Seleccione una opción
                </option>
                <option
                  *ngFor="let personType of personTypeList"
                  [value]="personType.label">
                  {{ personType.label }}
                </option>
              </select>
              <i>
                <p class="text-center" *ngIf="loadingImgPersonType">
                  <img src="assets/img/loading2.gif" alt="loader" />
                </p>
              </i>
            </label>
            <div
              *ngIf="
                reactiveForm.get('personType').invalid &&
                reactiveForm.get('personType').touched
              ">
              <p class="error">El tipo de persona es obligatorio</p>
            </div>
          </div>
        </ng-template>

        <div class="col-xs-12 col-md-6">
          <div class="col-md-2 pull-right" *ngIf="loadingImg">
            <p class="text-center">
              <img src="assets/img/loading2.gif" alt="loader" /> Cargando ...
            </p>
          </div>
        </div>
      </div>
    </fieldset>
    <app-ml-create-status-person
      #statusPersonView
      [statusData]="[{}]"
      [showSubmit]="false"></app-ml-create-status-person>
    <div>
      <button
        authorizedElement
        [authElementCode]="52592"
        [authElementName]="'BTN_INGRESAR_SOLICITUD'"
        class="btn btn-info"
        [disabled]="reactiveForm.invalid"
        (click)="submitForm()">
        Ingresar Solicitud
      </button>
    </div>
  </form>
</div>
